import classNames from 'classnames';
import ListItemContent from '@alltrails/denali/components/ListItemContent';
import SearchSparkle from '@alltrails/denali/icons/SearchSparkle';
import styles from './styles/styles.module.scss';

type Props = {
  html: string;
};

const NLSearchResultContent = ({ html }: Props) => {
  const icon = (
    <div className={styles.iconContainer}>
      <SearchSparkle color="--color-text-secondary" />
    </div>
  );

  return (
    <ListItemContent
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={<div className={classNames(styles.label, styles.htmlLabel)} dangerouslySetInnerHTML={{ __html: html }} />}
      testId="natural-language-search-result"
    />
  );
};

export default NLSearchResultContent;
